import React from 'react';
import { Label } from 'semantic-ui-react';

export const thaiRegularExpressionWithNumber = /^[-\s\d\u0e00-\u0e7e]+$/i;

export const thaiRegularExpressionWithOutNumber = /^[-\s\u0e00-\u0e7e]+$/i;

export const errorLabel = <Label color="red" pointing />;
